import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { Icon } from '../Icon';
var NotificationBellDotSvg = function NotificationBellDotSvg() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M6.91 4.115a7.186 7.186 0 0 1 8.565-1.218c-.394.321-.725.715-.973 1.162a5.705 5.705 0 0 0-6.548 1.104 5.75 5.75 0 0 0-1.676 4.06v4.804L4.89 16.815h14.222l-1.39-2.788V9.99a4.1 4.1 0 0 0 1.477-.173v3.86l2.302 4.62h-19l2.302-4.62V9.222c0-1.915.758-3.752 2.108-5.107M13.846 22h-3.692v-1.482h3.691z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 6,
    r: 3,
    fill: "#E23636"
  }));
};
export var NotificationBellDot = function NotificationBellDot(props) {
  return /*#__PURE__*/React.createElement(Icon, _extends({}, props, {
    component: NotificationBellDotSvg
  }));
};